import gql from 'graphql-tag'
import BaseDataTable from '@/components/BaseDataTable'

export const RECRUITER_LIST_ROW_FRAGMENT = gql`
  fragment RecruiterListRowFragment on CompanyRecruiter {
    id
    status
    email
    recruiterFee
    recruiterOwnershipDays
    recruiterOwnershipDaysLeft
    recruiter {
      id
      initials
      name
      avatar
      market {
        code
        name
      }
    }
    tags {
      id
      name
    }
  }
`

export const RecruitersList = gql`
  query recruitersList(
    $accounts: [ID!]
    $page: Int!
    $perPage: Int!
    $search: String
    $statuses: [RecruiterStatus!]
    $tags: [String!]
    $markets: [String!]
    $orderBy: [RecruiterOrderByClauseInput!]
  ) {
    companyRecruiters(
      accounts: $accounts
      page: $page
      first: $perPage
      search: $search
      statuses: $statuses
      tags: $tags
      markets: $markets
      orderBy: $orderBy
    ) {
      paginatorInfo {
        ...PaginatorInfoFragment
      }
      data {
        ...RecruiterListRowFragment
      }
    }
  }
  ${BaseDataTable.fragments.pagination}
  ${RECRUITER_LIST_ROW_FRAGMENT}
`

export const RECRUITER_FILTER_DATA_FRAGMENT = gql`
  fragment RecruiterFilterDataFragment on CompanyRecruiter {
    id
    status
    recruiter {
      market {
        code
        name
      }
    }
    tags {
      id
      name
    }
  }
`

export const RecruitersFilterDataQuery = gql`
  query recruitersFilterData($first: Int, $accounts: [ID!]) {
    companyRecruiters(first: $first, accounts: $accounts) {
      data {
        ...RecruiterFilterDataFragment
      }
    }
  }
  ${RECRUITER_FILTER_DATA_FRAGMENT}
`
